export const isBadWordRequest = (resource: string): boolean => {
  return resource === "bad-words";
};
